import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getRum } from "../../aws-app-monitor/rum";

export const PageTimeRumTracker: React.FC = () => {
  /* 
    CloudWatch RUM – Page Time Tracking
    ----------------------------------
    Tracks the total time a user spends on a page.
    Timing starts when the user comes on a page and is recorded when the user
    navigates away from that page.
  */
  const location = useLocation();

  useEffect(() => {
    const rum = getRum();
    if (!rum) return;

    // Normalize dynamic canvas routes (UUID-based) to a single "/canvas" route
    let route = location.pathname;
    if (route.startsWith("/canvas")) {
      route = "/canvas";
    }

    const startTime = Date.now();

    return () => {
      rum.recordEvent("page_time_spent", {
        route: route,
        duration_ms: Date.now() - startTime,
      });
    };
  }, [location.pathname]);

  return null;
};
